/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFormik } from "formik";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { useApi } from "@/hooks/useApi";
import { transformData } from "@/utils/transformData";
import { surgicalExpertiseMap } from "@/utils/mappings/surgicalExpertise";
import { surgicalBedStatusOptions } from "@/utils/options/surgicalBedStatusOptions";
import { surgicalCenterFilterModal } from "@/utils/initialValues/surgicalCenterFilterModal";
import { surgicalAttendanceStatusOptions } from "@/utils/options/surgicalAttendanceStatusOptions";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { ReactSelect } from "@/components/Selects/ReactSelect";

type Props = {
	setFilterModalShow: (filterModalShow: boolean) => void;
	surgicalTeamsOptions: ReactSelectOption[];
	filterModalShow: boolean;
	setFilters: (filters: Filters) => void;
};

export function FilterModal({
	filterModalShow,
	setFilterModalShow,
	surgicalTeamsOptions,
	setFilters,
}: Props) {
	const [expertiseOptions, setExpertiseOptions] = useState<ReactSelectOption[]>([]);
	const { api } = useApi();

	const handleFilterModalClose = () => setFilterModalShow(false);

	const formik = useFormik({
		initialValues: surgicalCenterFilterModal,
		onSubmit: (values) => {
			setFilters(values);
			handleFilterModalClose();
		},
	});

	async function getExpertises() {
		try {
			const { data } = await api.get("/surgical-center/expertises");

			const transformedData = transformData<SurgicalExpertise[]>(
				data.results,
				surgicalExpertiseMap
			);

			setExpertiseOptions(
				transformedData.map((expertise) => ({ value: expertise.id, label: expertise.name }))
			);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getExpertises();
	}, []);

	return (
		<Modal show={filterModalShow} onHide={handleFilterModalClose}>
			<Modal.Header className="d-flex justify-content-center border-0">
				<Modal.Title>Opções de filtro</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form id="filter-form" onSubmit={formik.handleSubmit}>
					<Form.Label htmlFor="status">Status</Form.Label>
					<ReactSelect
						placeholder="Selecione o status do paciente"
						inputId="status"
						options={surgicalAttendanceStatusOptions}
						onChange={(option) =>
							formik.setFieldValue(
								"surgical_attendance_status",
								(option as ReactSelectOption).value
							)
						}
						isSolid
					/>

					<FormattedFormControl
						id="expertise-date"
						type="date"
						className="form-control-solid"
						label="Data do Procedimento"
						labelClassName="mt-2"
						{...formik.getFieldProps("surgery_date")}
						name="surgery_date"
					/>

					<Form.Label htmlFor="expertise" className="mt-2">
						Procedimento
					</Form.Label>
					<ReactSelect
						placeholder="Selecione o procedimento"
						inputId="expertise"
						options={expertiseOptions}
						onChange={(option) =>
							formik.setFieldValue(
								"surgical_expertise_id",
								(option as ReactSelectOption).value
							)
						}
						isSolid
					/>

					<Form.Label htmlFor="surgical-team" className="mt-2">
						Equipe Cirúrgica
					</Form.Label>
					<ReactSelect
						placeholder="Selecione a equipe cirúrgica"
						inputId="surgical-team"
						options={surgicalTeamsOptions}
						onChange={(option) =>
							formik.setFieldValue(
								"surgical_team_id",
								(option as ReactSelectOption).value
							)
						}
						isSolid
					/>

					<Form.Label htmlFor="bed-status" className="mt-2">
						Status do Leito
					</Form.Label>
					<ReactSelect
						placeholder="Selecione o status do leito"
						inputId="bed-status"
						options={surgicalBedStatusOptions}
						onChange={(option) =>
							formik.setFieldValue("bed_status", (option as ReactSelectOption).value)
						}
						isSolid
					/>
				</Form>
			</Modal.Body>

			<Modal.Footer className="d-flex gap-2 border-0">
				<Button variant="secondary" className="py-2" onClick={handleFilterModalClose}>
					Cancelar
				</Button>

				<Button type="submit" className="py-2" form="filter-form">
					Aplicar
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
